export const Pagination = Object.freeze({
  ANSWERS_ON_PAGE_COUNT_FIRST: 15,
  ANSWERS_ON_PAGE_COUNT_SECOND: 25,
  ANSWERS_ON_PAGE_COUNT_THIRD: 50,

  USERS_ON_ADMIN_PAGE_COUNT_FIRST: 15,
  USERS_ON_ADMIN_PAGE_COUNT_SECOND: 25,
  USERS_ON_ADMIN_PAGE_COUNT_THIRD: 50,

  UNITS_ON_ADMIN_PAGE_COUNT_FIRST: 15,
  UNITS_ON_ADMIN_PAGE_COUNT_SECOND: 25,
  UNITS_ON_ADMIN_PAGE_COUNT_THIRD: 50,
});
